import Vue from "vue";
import App from "./App.vue";
import Vuesax from "vuesax";
import VueSweetalert2 from "vue-sweetalert2";
import Toasted from "vue-toasted";
import "sweetalert2/dist/sweetalert2.min.css";
import "material-icons/iconfont/material-icons.css";
import "vuesax/dist/vuesax.css";
import axios from "./axios.js";
import "../themeConfig.js";
import "./globalComponents.js";
import "./assets/scss/main.scss";
import "@/assets/css/main.css";
import router from "@/router";
import store from "./store/store";
import i18n from "./i18n/i18n";
import { VueHammer } from "vue2-hammer";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import StarRating from 'vue-star-rating'
import { formatApiError } from "@/utils/errorHandler";

require("./assets/css/iconfont.css");
Vue.use(VueHammer);
Vue.use(Vuesax);
Vue.use(VueSweetalert2);
Vue.use(Toasted, toastOption);
Vue.component('star-rating', StarRating)
Vue.prototype.$http = axios;
Vue.prototype.$formatError = formatApiError;

let toastOption = {
  theme: "toasted-primary",
  position: "top-right",
  duration: 3000,
  singleton: true,
  action: {
    text: "Cancel",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    },
  },
};
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
